import { render, staticRenderFns } from "./CoursePartExecution.vue?vue&type=template&id=6523e4b8&scoped=true"
import script from "./CoursePartExecution.vue?vue&type=script&lang=js"
export * from "./CoursePartExecution.vue?vue&type=script&lang=js"
import style0 from "./CoursePartExecution.vue?vue&type=style&index=0&id=6523e4b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6523e4b8",
  null
  
)

export default component.exports